/*
 * Copyright (c) 2020 Honeywell International Inc. All Rights Reserved.
 * Honeywell and its product names are among the trademarks and/or service marks owned
 * by Honeywell International, Inc., or its subsidiaries.
 *
 * For patent information, see http://www.hsmpats.com.
 */

import React, { Component } from 'react';
import { Grid, Input, Select } from '@scuf/common';
import PropTypes from 'prop-types';
import countryOptions from '../../common/countries';

/**
 * Class that renders the input and select boxes required to submit the SLA
 */
class SLAUserInputs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      firstNameTouched: false,
      lastNameTouched: false,
      emailTouched: false,
      phoneNumberTouched: false,
      companyNameTouched: false,
      cityTouched: false,
      streetAddressTouched: false,
      countryTouched: false,
      affiliateTouched: false,
    };
  }

  render() {
    const { onChange, renderError } = this.props;
    const {
      firstNameTouched,
      lastNameTouched,
      emailTouched,
      phoneNumberTouched,
      companyNameTouched,
      cityTouched,
      streetAddressTouched,
      countryTouched,
      affiliateTouched,
    } = this.state;
    return (
      <div>
        <Grid>
          <Grid.Row>
            <Grid.Column width={3} xsWidth={0} />
            <Grid.Column width={6} xsWidth={12}>
              <Input
                placeholder=""
                onChange={(value) => {
                  onChange('firstName', value);
                  onChange('validationError', false);
                }}
                label="First Name"
                indicator="required"
                fluid
                className="sla-user-inputs"
                error={renderError('firstName', 'First Name', firstNameTouched)}
                onBlur={() => {
                  this.setState({ firstNameTouched: true });
                }}
              />
              <Input
                placeholder=""
                onChange={(value) => {
                  onChange('lastName', value);
                  onChange('validationError', false);
                }}
                label="Last Name"
                indicator="required"
                fluid
                className="sla-user-inputs"
                error={renderError('lastName', 'Last Name', lastNameTouched)}
                onBlur={() => {
                  this.setState({ lastNameTouched: true });
                }}
              />
              <Input
                placeholder=""
                onChange={(value) => {
                  onChange('email', value);
                  onChange('validationError', false);
                }}
                label="Email"
                indicator="required"
                fluid
                className="sla-user-inputs"
                error={renderError('email', 'Email', emailTouched)}
                onBlur={() => {
                  this.setState({ emailTouched: true });
                }}
              />
              <Input
                placeholder=""
                onChange={(value) => {
                  onChange('phoneNumber', value);
                  onChange('validationError', false);
                }}
                label="Phone"
                indicator="required"
                fluid
                className="sla-user-inputs"
                error={renderError('phoneNumber', 'Phone', phoneNumberTouched)}
                onBlur={() => {
                  this.setState({ phoneNumberTouched: true });
                }}
              />
              <Input
                placeholder=""
                onChange={(value) => {
                  onChange('companyName', value);
                  onChange('validationError', false);
                }}
                label="Company Name"
                indicator="required"
                fluid
                className="sla-user-inputs"
                error={renderError('companyName', 'Company Name', companyNameTouched)}
                onBlur={() => {
                  this.setState({ companyNameTouched: true });
                }}
              />
              <Input
                placeholder=""
                onChange={(value) => {
                  onChange('streetAddress', value);
                  onChange('validationError', false);
                }}
                label="Street Address"
                indicator="required"
                fluid
                className="sla-user-inputs"
                error={renderError('streetAddress', 'Street Address', streetAddressTouched)}
                onBlur={() => {
                  this.setState({ streetAddressTouched: true });
                }}
              />
              <Input
                placeholder=""
                onChange={(value) => {
                  onChange('city', value);
                  onChange('validationError', false);
                }}
                label="City"
                indicator="required"
                fluid
                className="sla-user-inputs"
                error={renderError('city', 'City', cityTouched)}
                onBlur={() => {
                  this.setState({ cityTouched: true });
                }}
              />
              <Select
                placeholder="Select a country"
                options={countryOptions}
                onChange={(value) => {
                  onChange('country', value);
                  onChange('validationError', false);
                }}
                label="Country"
                indicator="required"
                fluid
                className="sla-user-inputs"
                error={renderError('country', 'Country', countryTouched)}
                onClose={() => {
                  this.setState({ countryTouched: true });
                }}
              />
              <Input
                placeholder=""
                onChange={(value) => {
                  onChange('affiliate', value);
                }}
                label="Affiliates"
                fluid
                className="sla-user-inputs"
              />
            </Grid.Column>
            <Grid.Column width={3} xsWidth={0} />
          </Grid.Row>
        </Grid>
      </div>
    );
  }
}

SLAUserInputs.propTypes = {
  onChange: PropTypes.func.isRequired,
  renderError: PropTypes.func.isRequired,
};

export default SLAUserInputs;
